import React from "react";
import { useTranslation } from "hooks";
import { Typography } from "components";
import classNames from "classnames";
import { request } from "@stemscopes/api";
import { endpoints } from "configs";
import { createError } from "../../../../../../components/notification/notification";
import styles from "./DahsboardLink.module.css";

const DashboardLink: React.FC<{
  linkClassName: string;
  textClassName: string;
  className: string;
}> = ({ linkClassName, textClassName, className }) => {
  const { t } = useTranslation();
  const [isDashboardLinkLoading, setIsDashboardLinkLoading] =
    React.useState(false);

  const goToDashboard = async (
    e: React.MouseEvent<HTMLElement>,
  ): Promise<any> => {
    e.preventDefault();

    if (isDashboardLinkLoading) {
      return;
    }

    setIsDashboardLinkLoading(true);

    try {
      const response = await request.get(endpoints.externalAnalyticsDashboard);
      if (response.data?.data?.redirectTo) {
        window.location.assign(response.data?.data?.redirectTo);
      }
    } catch {
      createError({ content: t("header.cantOpenDashboard") });
    } finally {
      setIsDashboardLinkLoading(false);
    }
  };

  return (
    <a
      href="/analytics_dashboard"
      title={t("header.openDashboard")}
      className={classNames(className, linkClassName, styles.link)}
      onClick={goToDashboard}
    >
      <Typography component="span" variant="p2" className={textClassName}>
        {t("header.dashboard")}
      </Typography>
    </a>
  );
};

export default DashboardLink;
